import React, { useCallback, useEffect, useState } from "react";
import { format } from "date-fns";

import { useStore } from "context/GlobalContext";
import CaseLogTable from "components/Tables/CaseLogTable";
import caseLogService from "api/casesAPI";
import Swal from "sweetalert2";

const CaseLog = () => {
  const { setDateRange, startDate, endDate, loading, setLoading } = useStore();

  const [data, setData] = useState([]);

  const searchDatabase = async (text) => {
    setLoading(true);

    const filter = await caseLogService
      .getCasesByDescription(text)
      .then((res) => {
        if (res.ok) {
          return res.data;
        } else {
          return [];
        }
      });
    setData(filter);
    setLoading(false);
  };

  const handleDelete = async (id) => {
    console.log("case id", id);

    const alertResult = Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      background: "#2b3445",
      color: "#fff",
      cancelButtonText: "Cancel",

      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });
    if ((await alertResult).isConfirmed) {
      const result = await caseLogService.del(id);
      if (result.ok) {
        Swal.fire({
          title: "Deleted!",
          text: "Your case has been deleted.",
          icon: "success",
          background: "#2b3445",
          color: "#fff",
          timer: 1500,
          showConfirmButton: false,
        });
        const filter = data.filter((item) => item.id !== id);
        setData(filter);
        return;
      }
      Swal.fire({
        title: "Error",
        text: "An error occured while adding the case",
        icon: "error",
        background: "#2b3445",
        color: "#fff",

        confirmButtonColor: "#d33",

        confirmButtonText: "OK !",
      });
    }
  };

  const getData = useCallback(async () => {
    setLoading(true);
    const filter = await caseLogService
      .getCasesBetweenDates(
        format(new Date(startDate), "MM/dd/yyyy hh:mm:ss aa"),
        format(new Date(endDate), "MM/dd/yyyy hh:mm:ss aa")
      )
      .then((res) => {
        if (res.ok) {
          return res.data;
        } else return [];
      });

    setData(filter);
    setLoading(false);
  }, [startDate, endDate, setLoading]);
  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <div className="flex flex-col">
      <div className="self-end   text-base   "></div>
      <CaseLogTable
        data={data}
        startDate={startDate}
        endDate={endDate}
        setDateRange={setDateRange}
        loading={loading}
        searchDatabase={searchDatabase}
        handleDelete={handleDelete}
      />
    </div>
  );
};

export default CaseLog;
